var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIdentityCross = function SvgIdentityCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39.82,
    height: 41.018,
    viewBox: "0 0 39.82 41.018",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18617",
    "data-name": "Group 18617",
    transform: "translate(-152.033 -65.982)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Warning_911852",
    transform: "translate(393.445 250.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17741",
    "data-name": "Group 17741",
    transform: "translate(-214.997 -185.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17740",
    "data-name": "Group 17740",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10800",
    "data-name": "Path 10800",
    d: "M6.707,0a1.034,1.034,0,0,0-.874.459L.144,9.308a.839.839,0,0,0,0,.927,1.032,1.032,0,0,0,.88.459H12.391a1.032,1.032,0,0,0,.88-.459.85.85,0,0,0,0-.927L7.582.459A1.034,1.034,0,0,0,6.707,0Zm0,.563a.451.451,0,0,1,.351.179L12.747,9.6a.338.338,0,0,1,0,.349.466.466,0,0,1-.356.184H1.024a.458.458,0,0,1-.356-.184.338.338,0,0,1,0-.349L6.357.743A.451.451,0,0,1,6.707.563Zm0,2.393a.3.3,0,0,0-.308.279V7.174a.3.3,0,0,0,.308.284.292.292,0,0,0,.3-.284V3.236A.291.291,0,0,0,6.707,2.956Zm0,5.065a.422.422,0,1,0,.453.419A.436.436,0,0,0,6.707,8.022Z",
    transform: "translate(-0.004 0)",
    fill: "#f9f9f9"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18594",
    "data-name": "Group 18594",
    transform: "translate(105 -210)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_verified_1983696",
    transform: "translate(47.033 284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9704",
    "data-name": "Path 9704",
    d: "M36.44,23.688a5.659,5.659,0,0,1,0-4.179l.178-.44a5.577,5.577,0,0,0-2.879-7.185l-.391-.183a5.288,5.288,0,0,1-2.879-2.969l-.142-.367a5.358,5.358,0,0,0-7-2.969l-.355.147a5.27,5.27,0,0,1-4.087,0l-.32-.147A5.31,5.31,0,0,0,11.632,8.4l-.142.293a5.288,5.288,0,0,1-2.879,2.969l-.32.147A5.593,5.593,0,0,0,5.448,19l.142.33a5.659,5.659,0,0,1,0,4.179l-.142.4a5.491,5.491,0,0,0,2.879,7.148l.355.147a5.289,5.289,0,0,1,2.879,2.969l.178.4a5.257,5.257,0,0,0,6.931,3.006l.391-.183a5.27,5.27,0,0,1,4.087,0l.32.147a5.29,5.29,0,0,0,6.966-2.969l.142-.293a5.289,5.289,0,0,1,2.879-2.969l.284-.11a5.533,5.533,0,0,0,2.879-7.185ZM19.522,28.637h0l-6.931-6.012,2.133-2.6,4.407,3.849,7.784-9.531,2.523,2.2-9.916,12.1Z",
    transform: "translate(-5.033 -4.988)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18593",
    "data-name": "Group 18593",
    transform: "translate(53.299 291.841)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9165",
    "data-name": "Rectangle 9165",
    width: 18.188,
    height: 18.865,
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_Cross_2180907",
    transform: "translate(3.665 2.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18592",
    "data-name": "Group 18592",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10932",
    "data-name": "Path 10932",
    d: "M25.522,22.769,29.7,19l2.341,2.124-4.165,3.754,4.165,3.769L29.7,30.757,25.522,27l-4.165,3.754L19,28.647l4.181-3.769L19,21.124,21.357,19Z",
    transform: "translate(-19 -19)",
    fill: "#3cb9c0",
    fillRule: "evenodd"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIdentityCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/identityCross.7be725ad.svg";
export { ForwardRef as ReactComponent };